export default "__VITE_ASSET__BZD845DU__"